import { Modal } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const ModalCreateUserStyles = styled(Modal)`
  width: 45rem;
`;
